import React from "react";
import Header from "../components/layout/Header";
import SelectSiteHeader from "src/components/layout/SelectSiteHeader";
import THPReport from "src/components/report/reportTHP/THPReport";
import { useDempStore } from "src/context/stores";
import { FoodSchoolReport } from "src/components/report";
import { DEMP_FEATURES } from "src/shared/config";

function ReportPage(props) {
  const [companyId, hidden] = useDempStore((state) => [state.companyId, state.hidden]);

  return (
    <>
      <Header pageTitle={"DEMP | Report"}>
        <SelectSiteHeader />
      </Header>

      {/* content report */}
      {/* <THPReport /> */}
      {!hidden.includes(DEMP_FEATURES.HEADER.REPORT_EV) ? (
        <THPReport />
      ) : !hidden.includes(DEMP_FEATURES.HEADER.REPORT_EN) ?(
        <FoodSchoolReport/>
      ):(
        <div className="flex items-center justify-center w-full h-[60vh]">
          <p>This company does not have any report at the moment</p>
        </div>
      )}
    </>
  );
}

export default ReportPage;
